document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector('.compare-oil-container');
  if (!container) return;

  const content = container.querySelector('.compare-content-wrapper');
  if (!content) return;

  const observerOptions = {
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        content.style.opacity = '1';
        content.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  content.style.opacity = '0';
  content.style.transform = 'translateY(30px)';
  content.style.transition = 'opacity 0.8s ease, transform 0.8s ease';

  observer.observe(container);
});
